module.exports = __webpack_public_path__ + "img/govnt.c8e6aed3.png";